import type { AppLocale } from '../i18n/messages';

/**
 * Дата записи словами языка интерфейса — «4 октября 2026», а не ISO `2026-10-04` (п. 17).
 * Без `Intl` (старый движок) остаётся ISO: некрасиво, но не неверно.
 *
 * <p>Отдельным модулем от {@link ./helpEntries}: ящику подсказок дата нужна сразу, а сами
 * тексты записей грузятся по требованию и в основной веб-бандл не входят.
 */
export function formatHelpDate(iso: string, locale: AppLocale): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  try {
    // Полдень по UTC: дата без времени не должна уехать на соседний день в чужом поясе.
    return new Intl.DateTimeFormat(locale === 'sr' ? 'sr-Latn' : locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(Date.UTC(y, m - 1, d, 12)));
  } catch {
    return iso;
  }
}
